import axios from 'axios'

const itsApi = axios.create({
	baseURL: process.env.VUE_APP_ITS_URL,
	headers: {
		'Accept': 'application/json',
      	'Content-Type': 'application/json'
	},
	transformRequest: [(data, headers) => { delete headers.common.Authorization; return JSON.stringify(data) }]
})

export default itsApi